import { Theme, Font } from '@oneamerica/dxp-ui-components';
import ColorConstants from '../../../../../constants/ColorConstants';

export default () =>
  Theme.Responsive.create({
    placeholderWrapper: {
      minHeight: 24,
      justifyContent: 'center',
    },
    modalTitle: {
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      fontFamily: Font.medium.fontFamily,
      fontSize: 18,
      fontWeight: '500',
      zIndex: -1,
      padding: 2,
      marginBottom: 12,
      marginRight: 20 + 18,
    },
    modalSubTitle: {
      fontSize: 12,
    },
    smModalSize: {
      margin: 'auto',
      maxHeight: '70%',
      maxWidth: '90%',
      flexGrow: 0,
      flexShrink: 0,
      flexBasis: 'auto',
    },
    mdModalSize: {
      margin: 'auto',
      maxHeight: '80%',
      minWidth: '66.66%',
      maxWidth: '70%',
    },
    lgModalSize: {
      marginVertical: 'auto',
      marginHorizontal: 'auto',
      maxHeight: '90%',
      minWidth: '41.66%',
      maxWidth: '50%',
    },
    smCheckboxWrapper: { flex: 3 },
    mdCheckboxWrapper: { flex: 2 },
    lgCheckboxWrapper: { flex: 1 },
    smCheckboxText: { fontSize: 16 },
    mdCheckboxText: { fontSize: 18 },
    lgCheckboxText: { fontSize: 18 },
    smCurrencyWrapper: { fontSize: 16, flex: 1 },
    mdCurrencyWrapper: { fontSize: 18, flex: 1 },
    lgCurrencyWrapper: { fontSize: 18, flex: 1 },
    placeholderText: {
      fontFamily: Font.regular.fontFamily,
      fontSize: 14,
      color: ColorConstants.iron,
    },
    needToMakeChange: {
      color: ColorConstants.iron,
    },
    serviceRequestBtn: {
      fontSize: 15,
      fontFamily: Font.medium.fontFamily,
    },
    customeServiceRequestBtn: {
      backgroundColor: Theme.Color.ice4,
      borderRadius: 24,
      paddingHorizontal: 16,
      paddingVertical: 12,
    },
    tableRow: {
      backgroundColor: Theme.Color.table.row.background,
      flex: 1,
      flexDirection: 'row',
    },
    evenRow: { backgroundColor: Theme.Color.table.row.background },
    oddRow: {
      backgroundColor: Theme.Color.table.row.oddBackground,
    },
    tableCell: {
      paddingVertical: Theme.Metrics.xxSmall,
      paddingHorizontal: Theme.Metrics.xSmall,
    },
    tableCellLeft: {
      flex: 1,
      borderColor: Theme.Color.table.cell.borderColor,
      borderRightWidth: 1,
    },
    tableCellRight: {
      flex: 2,
    },
    tableCellLeftText: {
      color: ColorConstants.iron,
      fontFamily: Font.regular.fontFamily,
    },
    tableCellRightText: {
      fontFamily: Font.medium.fontFamily,
      color: ColorConstants.iron,
    },
    horizontalDivider: {
      backgroundColor: ColorConstants.grey200,
      height: 1,
      width: '100%',
    },
  })();
